import { setCandidateRating } from "@src/entities/rating/api/request/setCandidateRating";
import { useMutation } from "@tanstack/react-query";

export const useSetCandidateRating = () => {
  return useMutation({
    mutationFn: setCandidateRating,
  });
};
